/* Fahmy 2026 theme behaviour. Sections re-initialise on theme editor load events. */
(function(){
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  },{threshold:.12, rootMargin:'0px 0px -6% 0px'}) : null;

  function reveal(root){
    root.querySelectorAll('.rv:not(.in)').forEach(function(el){ io ? io.observe(el) : el.classList.add('in'); });
  }

  function tabs(root){
    root.querySelectorAll('[data-fh-tabs]').forEach(function(w){
      var btns = w.querySelectorAll('.ptab'), panels = w.querySelectorAll('[data-panel]');
      btns.forEach(function(b){
        b.addEventListener('click', function(){
          btns.forEach(function(x){ var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-selected', on); });
          panels.forEach(function(p){ p.hidden = p.dataset.panel !== b.dataset.t; });
          var link = w.querySelector('[data-fh-all]'); if(link && b.dataset.url) link.href = b.dataset.url;
        });
      });
    });
  }

  function rail(root){
    root.querySelectorAll('[data-fh-rail]').forEach(function(r){
      var scope = r.closest('.fh') || root;
      var btns = scope.querySelectorAll('[data-camp]');
      var step = function(){ var c = r.querySelector('.card'); return c ? (c.offsetWidth + parseFloat(getComputedStyle(r).columnGap || 16)) * 2 : 400; };
      btns.forEach(function(b){ b.onclick = function(){ r.scrollBy({left: step() * (+b.dataset.camp), behavior:'smooth'}); }; });
      var sync = function(){ var max = r.scrollWidth - r.clientWidth - 2; btns.forEach(function(b){ b.disabled = (+b.dataset.camp < 0 ? r.scrollLeft <= 2 : r.scrollLeft >= max); }); };
      r.addEventListener('scroll', sync, {passive:true}); sync();
    });
  }

  function acc(root){
    root.querySelectorAll('.acc6').forEach(function(w){
      var ps = [].slice.call(w.querySelectorAll('.pane'));
      ps.forEach(function(p){
        var set = function(){ ps.forEach(function(x){ x.classList.toggle('on', x === p); }); };
        p.addEventListener('mouseenter', set); p.addEventListener('focus', set);
      });
    });
  }

  function init(root){ root = root || document; reveal(root); tabs(root); rail(root); acc(root); }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
